import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { DirectivesModule } from '@jht/brand-directives';
import { TranslateModule } from '@jht/brand-translate';
import { TranslateService } from '@jht/brand-translate';

import { ContentService } from '../../../shared/content/content.service';

interface FooterSocialItem {
    'social-icon': string;
    'icon-alt-text': string;
    'link-url': string;
}

interface FooterLegalItem {
    'link-url': string;
    title: string;
    'title-translated': string;
}

interface FooterNavigationItem {
    'link-url': string;
    title: string;
    'title-translated': string;
    category: string;
}
interface FooterNavList {
    category: string;
    items: FooterNavigationItem[];
}
@Component({
    selector: 'vision2-footer',
    imports: [CommonModule, DirectivesModule, TranslateModule],
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
    copyRight = '';
    socialData$: Observable<FooterSocialItem[]> = new Observable();
    legalData$: Observable<FooterLegalItem[]> = new Observable();
    navigationData$: Observable<FooterNavList[]> = new Observable();

    constructor(
        private contentService: ContentService,
        private translate: TranslateService,
    ) {}

    ngOnInit() {
        this.socialData$ = this.contentService.getComponent(
            'footer-social-icons',
            undefined,
            true,
        );
        this.legalData$ = this.contentService.getComponent(
            'footer-legal-links',
            undefined,
            true,
        );
        this.navigationData$ = this.contentService
            .getComponent('footer-navigation', undefined, true)
            .pipe(
                map((items: FooterNavigationItem[]) => {
                    const categoryMap = new Map<
                        string,
                        FooterNavigationItem[]
                    >();

                    items.forEach((item: FooterNavigationItem) => {
                        const category = item.category || 'Other';
                        if (!categoryMap.has(category)) {
                            categoryMap.set(category, []);
                        }
                        categoryMap.get(category)!.push(item);
                    });

                    const orderedNavItems: {
                        category: string;
                        items: FooterNavigationItem[];
                    }[] = [];
                    categoryMap.forEach((items, category) => {
                        orderedNavItems.push({ category, items });
                    });

                    return orderedNavItems;
                }),
            );

        const currentYear = new Date().getFullYear().toString();
        this.copyRight = this.translate
            .instant('SITE_COPYRIGHT')
            .replace('{{YEAR}}', currentYear);
    }

    originalOrder(a: any, b: any) {
        return 0;
    }
}
